var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15.167,
    height: 15.526,
    viewBox: "0 0 15.167 15.526",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 263",
    d: "M0,0H15.167V-15.526H0Z",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 723",
    transform: "translate(0 15.526)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 721",
    transform: "translate(7.055 -0.354)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 261",
    d: "M0,0,7.405-7.405-.009-14.819",
    fill: "none",
    stroke: "#191919",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 722",
    transform: "translate(0 -7.763)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 262",
    d: "M0,0H14.2",
    fill: "none",
    stroke: "#191919",
    strokeWidth: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.23dc76934713c2701e2569bfec0abaae.svg";
export { ForwardRef as ReactComponent };